import { render, staticRenderFns } from "./ReferralCode.vue?vue&type=template&id=12a254d4&"
import script from "./ReferralCode.vue?vue&type=script&lang=js&"
export * from "./ReferralCode.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCode.vue?vue&type=style&index=0&id=12a254d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports